import { ClientFetchService } from "@lib/helpers/clientFetchService";
import type { StoreData } from "@features/stores/types";
import type {
    ParcelShopAddress,
    ParcelShopCoordinates,
} from "@lib/api-services/services/shipping-methods-service/types";

export const getParcelShopsByCoordinates = async ({
    latitude,
    longitude,
}: ParcelShopCoordinates): Promise<StoreData[]> => {
    return await ClientFetchService.get<StoreData[]>(
        "/api/checkout/parcel-shops/search/coordinates",
        {
            params: {
                latitude,
                longitude,
            },
        }
    );
};

export const getParcelShopsByAddress = async ({
    city,
    postCode,
}: ParcelShopAddress): Promise<StoreData[]> => {
    return await ClientFetchService.get<StoreData[]>("/api/checkout/parcel-shops/search/address", {
        params: {
            city,
            postCode,
        },
    });
};
